import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';

export interface Period {
  number: number;
  name: TranslateResult;
  blocked: boolean;
}

export interface PeriodState {
  periodStartDate: string;
  periods: Period[];
  currentPeriod: Period;
  isLoadingPeriod: boolean;
}

const state: PeriodState = {
  periodStartDate: '',
  periods: [],
  currentPeriod: { number: 0, name: i18n.tc('noPeriod'), blocked: false },
  isLoadingPeriod: false,
};

export default state;
